import React, {Component} from "react";
import {Button, Modal, Input, Header, TextArea, Form, Dropdown} from "semantic-ui-react";
import {getPracticeList} from "../redux/modules/practices";
import {connect} from "react-redux";

class FeedbackModal extends Component {

    state = {
        practiceOptions: [],
        formData: {}
    }

    async componentDidMount() {
        const practices = await this.props.dispatch(getPracticeList());
        let practiceOptions = practices.map((practice, key) => ({
            text: practice.practice,
            value: practice.practice,
            key
        }));
        practiceOptions = [
            {text: 'Support', value: 'Support', key: practiceOptions.length + 1},
            ...practiceOptions
        ];
        this.setState({practices, practiceOptions});
    }

    onChange = (e, data) => {
        let formData = this.state.formData;
        formData[data.name] = data.value;
        this.setState({ ...this.state, formData });
        this.props.onChangeFeedback(formData);
    };

    onFileChange = async (e) => {
        e.persist();
        if (!e.target || !e.target.files) return;
        const value = await this.fileToBase64(e.target.files[0]);
        this.onChange(null, { name: 'file', value });
    };

    fileToBase64 = async (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (e) => reject(e);
        });

    render() {
        return (
            <Modal
                open={true}
                onClose={this.props.hideFeedbackModal}
                centered={false}
                size='tiny'
                closeIcon
            >
              <Header content='Feedback'/>
              <Modal.Content>
                  <Form>
                      <Form.Field>
                          <label>Practice/Support</label>
                          <Dropdown
                              search={true}
                              name='practice'
                              placeholder='Practice'
                              selection={true}
                              options={this.state.practiceOptions}
                              onChange={this.onChange}
                          />
                      </Form.Field>
                      <Form.Field>
                          <label>Subject</label>
                          <Input fluid={true} name='subject' placeholder='Subject' onChange={this.onChange} />
                      </Form.Field>
                      <Form.Field>
                          <label>Message</label>
                          <TextArea rows={6} fluid={true} name='message' onChange={this.onChange} />
                      </Form.Field>
                      <Form.Field>
                          <label>Attachments</label>
                          <input
                              name='file'
                              type='file'
                              onChange={this.onFileChange}
                          />
                      </Form.Field>
                  </Form>
              </Modal.Content>
              <Modal.Actions>
                <Button secondary onClick={this.props.hideFeedbackModal}>
                  Cancel
                </Button>
                <Button className='ui primary button' onClick={this.props.onClickFeedbackPage}>
                  Submit
                </Button>

              </Modal.Actions>
            </Modal>
        );
    }
}

export default connect(state => ({
    user: state.get('auth').get('user')
}))(FeedbackModal)